module.exports = __webpack_public_path__ + "static/media/check_out_french.de068b7e.jpg";